const WALLBOARD_API_VERSION = '2026-10-01';

const teamIdsQuery = (teamIds: string[]): string => teamIds.map((teamId) => `teamIds=${encodeURIComponent(teamId)}`).join('&');

const optionalQuery = (name: string, value: boolean | string | undefined | null): string =>
  value === undefined || value === null || value === '' ? '' : `&${name}=${encodeURIComponent(String(value))}`;

export const WallboardApiRoutes = {
  Access: {
    access: (): string => 'v2/wallboards/access',
    renew: (): string => 'v2/wallboards/access/renew',
    end: (): string => 'v2/wallboards/access/end',
  },
  Dashboard: {
    dashboard: (): string => `v2/wallboards/dashboard?api-version=${WALLBOARD_API_VERSION}`,
    widgets: (): string => `v2/wallboards/dashboard/widgets?api-version=${WALLBOARD_API_VERSION}`,
  },
  Data: {
    bootstrap: (): string => `v2/wallboards/data/bootstrap?api-version=${WALLBOARD_API_VERSION}`,
    serviceSessions: (teamIds: string[]): string =>
      `v2/wallboards/data/service-sessions?api-version=${WALLBOARD_API_VERSION}&${teamIds
        .map((teamId) => `teamIds=${encodeURIComponent(teamId)}`)
        .join('&')}`,
    teamMembers: (): string => `v2/wallboards/data/teams/members?api-version=${WALLBOARD_API_VERSION}`,
    conversationsByTimeSlots: (): string => `v2/wallboards/data/conversations-by-time-slots?api-version=${WALLBOARD_API_VERSION}`,
    outboundTasks: (): string => `v2/wallboards/data/outbound-tasks?api-version=${WALLBOARD_API_VERSION}`,
    callRecordCounts: (teamIds: string[], isProcessed?: boolean, currentlyHandled?: boolean): string =>
      `v2/wallboards/data/call-records/count?api-version=${WALLBOARD_API_VERSION}&${teamIdsQuery(teamIds)}` +
      `${optionalQuery('isProcessed', isProcessed)}${optionalQuery('currentlyHandled', currentlyHandled)}`,
    callRecordCountsByDay: (teamIds: string[], from: string): string =>
      `v2/wallboards/data/call-records/count-by-day?api-version=${WALLBOARD_API_VERSION}&${teamIdsQuery(teamIds)}` +
      `&from=${encodeURIComponent(from)}`,
    averageProcessingDurations: (teamIds: string[], fromDate?: string, toDate?: string): string =>
      `v2/wallboards/data/call-records/average-processing-duration?api-version=${WALLBOARD_API_VERSION}&${teamIdsQuery(teamIds)}` +
      `${optionalQuery('fromDate', fromDate)}${optionalQuery('toDate', toDate)}`,

    users: (): string => `v2/wallboards/data/users?api-version=${WALLBOARD_API_VERSION}`,
    userStateWidgetData: (): string => `v2/wallboards/data/user-state-widget-data?api-version=${WALLBOARD_API_VERSION}`,
    userSupervisorWidgetData: (): string => `v2/wallboards/data/user-supervisor-widget-data?api-version=${WALLBOARD_API_VERSION}`,
    userPerformanceWidgetData: (from: string, to: string): string =>
      `v2/wallboards/data/user-performance-widget-data?api-version=${WALLBOARD_API_VERSION}` +
      `&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
  },
};
